import Stepper from 'components/Stepper';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Card, Button } from 'reactstrap';
import AlertModal from 'components/AlertModal';
import { useAlertPlus } from 'hooks';
import { getRematriculacionPreferenceId } from '../../../features/mercadopago/mercadopagoAPI';
import { getRematriculacionAmount } from '../../../features/rematriculacion/rematriculacionAPI';

interface PaymentProps extends RouteComponentProps<any, any, any> {}

const Payment: React.FC<PaymentProps> = props => {
  const { rematriculacion } = props.location.state || {};

  const [showAlert, message, alertCallback, alert] = useAlertPlus('');

  const [disabledSend, setDisabledSend] = useState<boolean>(true);
  const [paymentAmount, setPaymentAmount] = useState<number | null>();

  useEffect(() => {
    const loadData = async () => {
      setDisabledSend(true);
      try {
        const amount = await getRematriculacionAmount();
        if (amount) {
          setPaymentAmount(amount);
          setDisabledSend(false);
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {}
    };

    loadData();
  }, []);

  const handleStartCheckout = async () => {
    try {
      if (paymentAmount) {
        const body = {
          id: rematriculacion.id,
          description: `Pago de Rematriculación de solicitud: ${rematriculacion.id}`,
        };

        const response = await getRematriculacionPreferenceId(body);
        if (response && response.status == 'ok') {
          const preferenceId = response.payload;

          const baseUrl = 'https://www.mercadopago.com.ar';
          const checkoutPath = '/checkout/v1/redirect';
          const link = `${baseUrl}${checkoutPath}?preference_id=${preferenceId}`;

          window.open(link, '_blank');
        } else {
          alert('Error iniciando checkout');
          console.error(response);
        }
      }
    } catch (err) {
      console.error(err);
      alert('Error iniciando checkout');
    }
  };

  return (
    <div>
      <Card
        style={{ padding: '1rem 15rem', display: 'flex', alignItems: 'center' }}
        className='max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8'
      >
        {/* Stepper */}
        <Stepper
          currentStep={2}
          steps={['', 'Pago']}
          title='Pago derecho de rematriculación'
        />
        <p>Total a pagar: ${paymentAmount}</p>
        <Button
          className='btn-custom'
          style={{ marginTop: '10rem' }}
          color='primary'
          onClick={handleStartCheckout}
          disabled={disabledSend}
        >
          Realizar Pago
        </Button>
      </Card>
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={alertCallback}
      />
    </div>
  );
};

export default Payment;
